import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "belomotors_token";
// Phase 12 — impersonation. When an admin is "viewing as" another user, we
// store their target-user JWT here; the interceptor prefers it over the admin
// token so every API call is scoped to the impersonated identity. The admin's
// original token stays under TOKEN_KEY so "Exit view mode" is a no-network op.
export const IMPERSONATION_TOKEN_KEY = "belomotors_impersonation_token";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // send session_token cookie for Google-auth users
});

api.interceptors.request.use((config) => {
  const imp = localStorage.getItem(IMPERSONATION_TOKEN_KEY);
  const token = imp || localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
